
const landing = {
  // Landing Page
  landing: {
    title: "Revolutionize Your Betting",
    titleHighlight: "with AI",
    titleEnd: "Precision",
    subtitle: "Experience the power of artificial intelligence in sports betting. Our advanced algorithms analyze millions of data points to provide you with accurate predictions and profitable insights.",
    startNow: "Start Now",
    createFreeAccount: "Create Free Account",
    dashboardAlt: "Titan Predictions Dashboard",
    analysisTitle: "AI-Powered Analysis",
    analysisSubtitle: "Real-time insights for better decisions",
    whyChoose: "Why Choose Titan Predictions?",
    whyChooseDesc: "Discover the advantages that make us the preferred choice for smart bettors worldwide.",
    feature1Title: "Accurate Predictions",
    feature1Desc: "Our AI models deliver consistently high accuracy rates across all major sports and leagues.",
    feature2Title: "Risk Management",
    feature2Desc: "Advanced algorithms help you manage risk and maximize your betting portfolio returns.",
    feature3Title: "Real-time Updates",
    feature3Desc: "Get instant updates on odds changes, team news, and match insights as they happen.",
    readyTitle: "Ready to Transform Your Betting?",
    readyDesc: "Join thousands of successful bettors who have already discovered the power of AI-driven predictions.",
    footerDesc: "The leading platform for AI-powered sports betting predictions and analytics.",
    resources: "Resources",
    analysis: "Analysis",
    predictions: "Predictions",
    statistics: "Statistics",
    company: "Company",
    aboutUs: "About Us",
    blog: "Blog",
    contact: "Contact",
    legal: "Legal",
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    responsibility: "Responsible Gambling",
    copyright: "© {year} Titan Predictions. All rights reserved."
  }
};

export default landing;
